import { createFileRoute } from "@tanstack/react-router";
import {
  getAssetsAllAssetsListQueryOptions,
  getAssetsRetrieveQueryOptions,
  getStatesListInfiniteQueryOptions,
} from "@/api/wai/wai3Api";
import { GrunndataAssetDetail } from "@/components/System/GrunndataDetails";

function GrunndataAssetRoute() {
  const { systemName, assetGroupName, assetName } = Route.useParams();
  return (
    <GrunndataAssetDetail
      systemName={systemName}
      assetGroupName={assetGroupName}
      assetName={assetName}
    />
  );
}

export const Route = createFileRoute("/_auth/grunndata/$systemName/$assetGroupName/$assetName")({
  component: GrunndataAssetRoute,
  beforeLoad: ({ params }) => {
    return {
      getTitle: () => params.assetName,
    };
  },
  loader: ({ context: { queryClient }, params: { assetName, assetGroupName } }) => {
    void queryClient.query(getAssetsRetrieveQueryOptions(assetName));
    void queryClient.fetchInfiniteQuery(
      getStatesListInfiniteQueryOptions({
        page_size: 20,
        order: ["-state"],
        assetGroup: [assetGroupName],
        asset: [assetName],
      }),
    );
    void queryClient.query(getAssetsAllAssetsListQueryOptions({ assetGroups: [assetGroupName] }));
  },
});
